import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationDetoxificationPhase1DiagramContent } from "./MethylationDetoxificationPhase1Diagram";
import { MethylationDetoxificationPhase1KeyContent } from "./MethylationDetoxificationPhase1Key";

const SvgMethylationDetoxificationPhase1DiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 871, 1087)}
      viewBox={diagramOnly ? "0 142 1024 871" : "0 0 1024 1087"}
    >
      <g id="methylation-detoxification-phase1-diagram+key" clipPath="url(#clip0_18382_42117)">
        <rect width={1024} height={diagramOnly ? 871 : 1087} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationDetoxificationPhase1KeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationDetoxificationPhase1DiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18382_42117">
          <rect width={1024} height={1087} fill="white" />
        </clipPath>
        <clipPath id="clip1_18382_42117">
          <rect width={1024} height={871} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationDetoxificationPhase1DiagramKey;
